import React from 'react'
import coin from '../Assets/coin.png'

const LatestResults = () => {
  return (
    <div className='latest-res rounded-lg'>
        
        <div className='flex justify-between p-3 px-4'>
            <p className='text-gray-300 text-sm font-bold'>Lottery Name</p>
            <p className='text-gray-300 text-sm font-bold mr-10'>Jackpot Numbers</p>
        </div>
        <div>
          {
          //jackpot wrapper
          }
          {Array.from({ length: 6 }, (_, i) => (
            <div className='flex justify-between space-y-3 p-2'>
              <div className='flex flex-col space-y-1'>
                <img width={30} src={coin} alt=''/>
                <p className='text-white font-bold'>Lottery Name</p>
                <p className='font-bold text-gray-300 text-sm'>01/01/2025, {i}:{i * 2}:00</p>
              </div>
              <div className='flex space-x-2 p-2'>
              {Array.from({ length: 20 }, (_, i) => (
                <p className='white-ball text-center cursor-pointer text-bold text-black'>{i % 6}</p>
              ))}
              </div>
            </div>
          ))}
        </div>
    </div>
  )
}

export default LatestResults